
import Vue from 'vue';
import Component from "vue-class-component";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import {
    AddTemplateRequest,
    factory,
    ResultError,
    SysAdminTemplatesClient,
    TemplateModel
} from "@/api-client";
import toasts from "@/components/Toasts";
import AdministrationDetailviewLayout from "@/features/administration/AdministrationDetailviewLayout.vue";
import ErrorsSummary from "@/components/ErrorsSummary.vue";
import { NavigationGuardNext } from 'vue-router';
import { Prop } from 'vue-property-decorator';

interface Props {
    id: string;
    preloadedTemplate: TemplateModel;
}

@Component({
    components: {
        SectionPageHeading,
        HeadingWave,
        AdministrationDetailviewLayout,
        ErrorsSummary
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<EditApplicationTemplate>) {
        const props = to.meta!.props as Props;
        Promise.all([
            new SysAdminTemplatesClient().get(to.params.id)
        ]).then(values => {
            props.id = to.params.id;
            props.preloadedTemplate = values[0]
            next();
        }).catch(e => next(e))
    },
    created() {
        this.model.nameEng = this.template.name.english;
        this.model.nameEst = this.template.name.estonian;
        this.model.id = this.template.id;
    }
})
export default class EditApplicationTemplate extends Vue {
    @Prop({ required: true })
    id!: string;
    @Prop({ required: true })
    preloadedTemplate!: TemplateModel;
    model: AddTemplateRequest = factory.create(AddTemplateRequest);

    template = this.preloadedTemplate;
    templateJson = JSON.stringify(this.template.templateJson, undefined, 4);
    validationError: ResultError = ResultError.createEmpty();

    async change(dryRun: boolean) {
        this.validationError.clear();
        this.model.dryRun = dryRun;
        this.model.update = true;
        try {
            this.model.templateJson = JSON.parse(this.templateJson);

        } catch (error) {
            this.validationError.appendMessage(this.$ls.Administration_Validation_JsonIsInvalid);
            toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove);
            return;
        }

        await new SysAdminTemplatesClient().add(this.model)
            .then(
                successResponse => {
                    if (!this.model.dryRun) {
                        this.$router.push({ name: 'application-templates' });
                        toasts.success(this.$ls.Administration_ApplicationTemplates_ApplicationTemplateSaved);
                    } else {
                        toasts.success(this.$ls.Administration_Toast_Success_JsonIsValid);
                    }
                },
                (errorResponse: ResultError) => {
                    this.validationError = errorResponse;
                    toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove);
                });
    }


}
